export default __webpack_public_path__ + "static/media/blog3.36161f26.png";